import Button from "@mui/material/Button";
import React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { LoginContextData } from "../Declarations";
import { useState } from "react";
import { useVerify2FA, IVerify2FARequest, Verify2FAResponse } from "../hooks/useVerify2FA";

interface IEnter2FAProps {
    data: LoginContextData;
    onVerified: () => void;
}

export const Enter2FA = ({ data, onVerified }: IEnter2FAProps) => {
    const [code, setCode] = useState<string>("");
    const [error, setError] = useState<string | null>(null);

    // Narrow the values to satisfy hook input
    const BrowserFingerprint: string = data.BrowserFingerprint !== undefined ? data.BrowserFingerprint : "";
    const username: string = data.UserName !== undefined ? data.UserName : "";
    const password: string = data.Password !== undefined ? data.Password : "";
    const UserID: number = data.UserID !== undefined ? data.UserID : 0;

    const verifyMutation = useVerify2FA();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        const payload: IVerify2FARequest = {
            AuthCode: code,
            BrowserFingerprint: BrowserFingerprint,
            Password: password,
            UserAgent: navigator.userAgent,
            UserID: UserID,
            UserName: username,
        };

        verifyMutation.mutate(
            payload,
            {
                onError: (err: unknown) => {
                    let message = "Invalid code";
                    if (typeof err === "object" && err !== null && "message" in err) {
                        message = String((err as any).message);
                    }
                    setError(message);
                },
                onSuccess: (response: Verify2FAResponse) => {
                    if (response.ValidCode) {
                        onVerified();
                    }
                    else {
                        setError(response.LoginMessage);
                    }
                },
            }
        );
    };

    return (
        <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
                <Typography sx={{ fontWeight: "bold" }} variant="h5">Enter Two-Factor Authentication Code</Typography>
                <TextField
                    fullWidth={true}
                    label="2FA Code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            handleSubmit(event);
                        }
                    }}
                />
                {error !== null && <p className="error">{error}</p>}
                <Button
                    color="primary"
                    disabled={verifyMutation.isPending}
                    fullWidth={false}
                    sx={{ width: "50%" }}
                    type="submit"
                    variant="contained"
                >{verifyMutation.isPending ? "Verifying..." : "Verify"}</Button>
            </Stack>
        </form>
    );
};
